import { useEffect, useState } from "react";
import { fetchPublicStatus, STATUS_POLL_MS } from "@/lib/public-status";

export default function usePublicStatus() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let timer;

    const load = async () => {
      try {
        const body = await fetchPublicStatus();
        if (!cancelled) {
          setData(body);
          setError(null);
        }
      } catch (err) {
        if (!cancelled) setError(err?.message || "Failed to load status");
      }
    };

    load();
    timer = window.setInterval(load, STATUS_POLL_MS);
    return () => {
      cancelled = true;
      window.clearInterval(timer);
    };
  }, []);

  return { data, error, banners: data?.maintenance?.banners || [] };
}
